var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatliteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9993 17L13.9993 14M18.9993 15C18.9993 13.4087 18.3671 11.8826 17.2419 10.7574C16.1167 9.63214 14.5906 9 12.9993 9M22.9993 15C22.9993 12.3478 21.9457 9.8043 20.0703 7.92893C18.195 6.05357 15.6514 5 12.9993 5M5.99927 12C5.18371 13.3951 4.85341 15.0211 5.05999 16.6238C5.26657 18.2265 5.9984 19.7155 7.14106 20.8582C8.28372 22.0009 9.7728 22.7327 11.3755 22.9393C12.9782 23.1459 14.6042 22.8156 15.9993 22L5.99927 12Z",
    stroke: "white",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatliteIcon);
export default __webpack_public_path__ + "static/media/satliteIcon.0217accd02e4d9a4fc5f204023cdf50a.svg";
export { ForwardRef as ReactComponent };